import React from 'react';
import PropTypes from 'prop-types';

// Components
import Modal from '../modal';
import Button from '../button';

import './style.css';

class ShareModal extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      copied: false,
      error: false
    };

    this.onClickCopy = this.onClickCopy.bind(this);
  }

  /**
   * Event handler executed when the user clicks the
   * copy button
   */
  onClickCopy() {
    this.input.select();

    try {
      document.execCommand('copy');
      this.setState({ copied: true });

      setTimeout(() => {
        this.setState({ copied: false });
        this.input.blur();
      }, 2000);
    } catch (err) {
      this.setState({ error: true });
    }
  }

  render() {
    const { isOpen, onRequestClose, url } = this.props;
    const { copied, error } = this.state;

    return (
      <Modal title="Share" isOpen={isOpen} onRequestClose={onRequestClose}>
        <div className="c-share-modal">
          <input type="text" value={url} readOnly ref={(node) => { this.input = node; }} />
          <Button onClick={this.onClickCopy}>
            {copied ? 'Copied!' : 'Copy'}
          </Button>
          { error && <p>Please copy manually the URL above.</p> }
        </div>
      </Modal>
    );
  }
}

ShareModal.propTypes = {
  // URL of the page to share
  url: PropTypes.string.isRequired,
  // Whether the modal is opened
  isOpen: PropTypes.bool.isRequired,
  // Callback to close the modal
  onRequestClose: PropTypes.func.isRequired
};

export default ShareModal;



// WEBPACK FOOTER //
// ./src/components/share-modal/component.js